import React, { PropsWithChildren } from "react";
import { styled } from "styled-components";

const Border = styled.div`
  border: 2px dashed ${(props) => props.theme.colours.borders};
  border-radius: 6px;
  padding: 5rem 25%;
`;

const EmptyStateMessage = styled.p`
  text-align: center;
`;

const EmptyStateIconWrapper = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  color: ${(props) => props.theme.colours.primary};
  background: ${(props) => props.theme.colours.blue[50]};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const EmptyStateIcon: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <EmptyStateMessage>
      <EmptyStateIconWrapper>{children}</EmptyStateIconWrapper>
    </EmptyStateMessage>
  );
};

export const EmptyState: React.FC<React.PropsWithChildren> & { Message: typeof EmptyStateMessage } & {
  Icon: typeof EmptyStateIcon;
} = ({ children, ...rest }) => <Border {...rest}>{children}</Border>;

EmptyState.Message = EmptyStateMessage;
EmptyState.Icon = EmptyStateIcon;
